export default "__VITE_ASSET__Dozr$jug__"